import { boolean, nullable, object, optional, parse, picklist, pipe, string, transform, url } from "valibot";

const environmentSchema = object({
  // We use localdev instead of "local" becase Vite does not allow local
  // https://github.com/vitejs/vite/commit/9509327538663de8fc5c7e1ab321b2a1b3a63738
  MODE: picklist(["localdev", "staging", "production", "test"]),
  ATI_TENANT: optional(string()),
  DEV: boolean(),
  PROD: boolean(),
  ATI_API_BASE_URL: pipe(string(), url()),
  ATI_PUBLIC_POSTHOG_KEY: string(),
  ATI_PUBLIC_POSTHOG_HOST: string(),
  ATI_PUBLIC_SENTRY_ORGANIZATION: string(),
  ATI_PUBLIC_SENTRY_PROJECT_ID: pipe(
    string(),
    transform(value => Number(value))
  ),
  ATI_PUBLIC_SENTRY_DSN: nullable(string()),
  ATI_AUTH0_DOMAIN: string(),
  ATI_AUTH0_CLIENT_ID: string(),
  ATI_AUTH0_AUDIENCE: string(),
  ATI_AUTH0_CONNECTION: optional(string())
});

export default parse(environmentSchema, import.meta.env);
